import { Controller } from 'stimulus';

export default class extends Controller {
  static targets = ['input', 'otherText', 'charCounter', 'charCount'];

  static values = { autoSubmit: Boolean };

  connect() {
    this.updateLabelState();
    // Initialize character count if otherText exists
    if (this.hasOtherTextTarget) {
      this.updateCharCount();
    }
  }

  // Handle label clicks and Enter key presses
  select(event) {
    event.preventDefault();
    const input = this.findInputInLabel(event.target);
    if (input) {
      input.click();
      this.updateLabelState();
    }
  }

  // Handle text field clicks to auto-select the "Other" option
  selectOtherOption(event) {
    const input = this.findInputInLabel(event.target);
    if (input && !input.checked) {
      input.click();
    }
  }

  // Auto-submit form when option is selected (if enabled and allowed by input)
  submitOnSelect(event) {
    const input = event.target;
    const shouldAutoSubmit = input.dataset.autoSubmit === 'true';

    if (this.autoSubmitValue && shouldAutoSubmit) {
      event.target.form?.requestSubmit();
    }
  }

  // Focus on "Other" text field when its option is selected
  focusOther(event) {
    if (event.target.checked && this.hasOtherTextTarget) {
      this.otherTextTarget.focus();
    }
  }

  // Update character count display
  updateCharCount() {
    if (!this.hasOtherTextTarget || !this.hasCharCountTarget) return;

    const currentLength = this.otherTextTarget.value.length;
    const maxLength = 60;

    this.charCountTarget.textContent = currentLength;

    // Update data-state attribute for Tailwind styling
    const counter = this.charCounterTarget;

    if (currentLength >= maxLength) {
      counter.dataset.state = 'at-limit';
    } else if (currentLength >= maxLength - 10) {
      counter.dataset.state = 'near-limit';
    } else {
      counter.dataset.state = 'default';
    }
  }

  // Update all label checked states based on input state
  updateLabelState() {
    this.inputTargets.forEach((input) => {
      input.labels?.forEach((label) => {
        label.dataset.checked = input.checked;
      });
    });
  }

  // Private helper methods
  findInputInLabel(element) {
    const label = element.closest('label');
    return label?.querySelector('input[type=radio], input[type=checkbox]');
  }
}
